import React from 'react';
import { useHistory } from 'react-router-dom';
import { storage } from 'modules/common/helper';
import Button from 'modules/common/input/Button';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import FormInputPin from 'modules/common/input/FormInputPin';
import { useVerifyCode } from '../hooks';
import * as c from '../constants';

const INIT_FORM = {
  code: '',
};

function VerifyCodeForm() {
  const detail = storage.get('forgot-password-detail') ?? {};
  const [isApiLoading, verifyCode] = useVerifyCode();
  const history = useHistory();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: INIT_FORM,
    resolver: yupResolver(c.schema),
    reValidateMode: 'onSubmit',
  });

  const handleOnSubmit = (form) => {
    const args = {
      ...detail,
      otp: form?.code,
    };

    verifyCode(args, () => {
      history.push(`/change-password`);
    });
  };

  return (
    <form onSubmit={handleSubmit(handleOnSubmit)}>
      <div className="space-y-8">
        <Controller
          control={control}
          name="code"
          render={({ field: { onChange, value, name } }) => (
            <FormInputPin
              name={name}
              value={value || ''}
              count={6}
              pinClassName="w-20 h-20 rounded text-gray-500 text-3xl font-medium"
              inActivePinClassName="border border-gray-300"
              activePinClassName="border-2 border-primary-500 animate-pulse"
              error={errors?.code}
              onChange={(e) => {
                onChange(e);
              }}
            />
          )}
        />
        <Button
          type="submit"
          isLoading={isApiLoading}
          className="btn primary md font-base text-sm"
          label="Next"
        />
      </div>
    </form>
  );
}
VerifyCodeForm.defaultProps = {};

VerifyCodeForm.propTypes = {};

export default VerifyCodeForm;
